module.exports = __webpack_public_path__ + "static/img/app04.94b7d87.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app04.png
// module id = aucU
// module chunks = 1